import { Panel } from './view/panel';
import { Trigger } from './view/trigger';

export { HIERARCHY_EVENTS, getDefaultHierarchyConfig } from './constants';
export * from './controller';
export * from './frame-source';
export { type HierarchyConfig } from './types';

export const Hierarchy = {
    Trigger,
    Panel,
};
